import { useEffect } from "react";

const SITE_URL = "https://theravensquill.co.za";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

function setMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(data) {
  document.head.querySelectorAll("script[data-seo-jsonld]").forEach((n) => n.remove());
  if (!data) return;
  const arr = Array.isArray(data) ? data : [data];
  arr.forEach((obj) => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.setAttribute("data-seo-jsonld", "");
    s.text = JSON.stringify(obj);
    document.head.appendChild(s);
  });
}

// Sets the document title, social meta, canonical URL and JSON-LD per route.
export const Seo = ({
  title,
  description,
  path,
  jsonLd,
  image = DEFAULT_OG_IMAGE,
  type = "website",
  ogTitle,
}) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("name", "description", description);
    setMeta("property", "og:title", ogTitle || title || document.title);
    setMeta("property", "og:description", description || "");
    setMeta("property", "og:type", type);
    setMeta("property", "og:image", image);
    setMeta("property", "og:image:width", "1200");
    setMeta("property", "og:image:height", "630");
    if (path != null) setMeta("property", "og:url", SITE_URL + path);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", ogTitle || title || document.title);
    setMeta("name", "twitter:description", description || "");
    setMeta("name", "twitter:image", image);
    if (path != null) setCanonical(SITE_URL + path);
    setJsonLd(jsonLd);
  }, [title, description, path, image, type, ogTitle, JSON.stringify(jsonLd)]);
  return null;
};
